/// //////////////////////////
// Imports
/// /////////////////////////
import '../scss/app.scss'
import SidebarComp from './components/Sidebar'
import * as Components from './components'
import {
  errorAlert,
  successAlert,
  infoAlert,
  warningAlert,
  clearAlerts,
  clearAlertsAsync,
  removeAlert,
  getAlerts,
  StoreAlertsState as SNS,
  StoreAlert as SN
} from './store/alertsSlice'
import Paw from './models/PawModel'
import App from './models/App'
import Bloc from './models/Bloc'
import Context from './models/Context'
import Folder from './models/Folder'
import Space from './models/Space'
import User from './models/User'
import ViewFolder from './models/ViewFolder'
import Doc from './models/Doc'
import View from './models/View'
import Group from './models/Group'
import PlugandworkAppClass from './utils/PlugandworkApp'
import { PawConnected, IViewProps } from './interfaces/view_loader'
import * as storeMethods from './store'
import SettingsFieldClass, * as settingsFields from './utils/SettingsField'
import { EnhancedStore } from '@reduxjs/toolkit'
import { i18nInstance as i18nI } from './i18n'

/// //////////////////////////
// Export
/// /////////////////////////

// Components
export const Sidebar = SidebarComp
export const Alert = Components.Alert
export const Badge = Components.Badge
export const Breadcrumb = Components.Breadcrumb
export const BreadcrumbItem = Components.BreadcrumbItem
export const Button = Components.Button
export const ButtonDropdown = Components.ButtonDropdown
export const ButtonGroup = Components.ButtonGroup
export const ButtonToggle = Components.ButtonToggle
export const ButtonToolbar = Components.ButtonToolbar
export const Card = Components.Card
export const CardBody = Components.CardBody
export const CardColumns = Components.CardColumns
export const CardDeck = Components.CardDeck
export const CardFooter = Components.CardFooter
export const CardGroup = Components.CardGroup
export const CardHeader = Components.CardHeader
export const CardImg = Components.CardImg
export const CardImgOverlay = Components.CardImgOverlay
export const CardLink = Components.CardLink
export const CardSubtitle = Components.CardSubtitle
export const CardText = Components.CardText
export const CardTitle = Components.CardTitle
export const Carousel = Components.Carousel
export const CarouselItem = Components.CarouselItem
export const CarouselControl = Components.CarouselControl
export const CarouselIndicators = Components.CarouselIndicators
export const CarouselCaption = Components.CarouselCaption
export const Col = Components.Col
export const Collapse = Components.Collapse
export const Container = Components.Container
export const CustomInput = Components.CustomInput
export const Dropdown = Components.Dropdown
export const DropdownItem = Components.DropdownItem
export const DropdownMenu = Components.DropdownMenu
export const DropdownToggle = Components.DropdownToggle
export const Fade = Components.Fade
export const Form = Components.Form
export const FormFeedback = Components.FormFeedback
export const FormGroup = Components.FormGroup
export const FormText = Components.FormText
export const Input = Components.Input
export const InputGroup = Components.InputGroup
export const InputGroupAddon = Components.InputGroupAddon
export const InputGroupButtonDropdown = Components.InputGroupButtonDropdown
export const InputGroupText = Components.InputGroupText
export const Jumbotron = Components.Jumbotron
export const Label = Components.Label
export const ListGroup = Components.ListGroup
export const ListGroupItem = Components.ListGroupItem
export const ListGroupItemHeading = Components.ListGroupItemHeading
export const ListGroupItemText = Components.ListGroupItemText
export const Media = Components.Media
export const Modal = Components.Modal
export const ModalBody = Components.ModalBody
export const ModalFooter = Components.ModalFooter
export const ModalHeader = Components.ModalHeader
export const Nav = Components.Nav
export const Navbar = Components.Navbar
export const NavbarBrand = Components.NavbarBrand
export const NavbarText = Components.NavbarText
export const NavbarToggler = Components.NavbarToggler
export const NavItem = Components.NavItem
export const NavLink = Components.NavLink
export const Pagination = Components.Pagination
export const PaginationItem = Components.PaginationItem
export const PaginationLink = Components.PaginationLink
export const Popover = Components.Popover
export const PopoverBody = Components.PopoverBody
export const PopoverHeader = Components.PopoverHeader
export const Progress = Components.Progress
export const Row = Components.Row
export const Spinner = Components.Spinner
export const TabContent = Components.TabContent
export const Table = Components.Table
export const TabPane = Components.TabPane
export const Toast = Components.Toast
export const ToastBody = Components.ToastBody
export const ToastHeader = Components.ToastHeader
export const Tooltip = Components.Tooltip
export const Util = Components.Util
export const SettingsField = SettingsFieldClass
export const SettingsFieldText = settingsFields.SettingsFieldText
export const SettingsFieldSelect = settingsFields.SettingsFieldSelect
export const SettingsFieldJSON = settingsFields.SettingsFieldJSON
export const PlugandworkApp = PlugandworkAppClass

// Store
export const getStore = storeMethods.getStore
// @ts-ignore
export const store: EnhancedStore<storeMethods.RootState> = new Proxy(
  {},
  {
    get: function (oTarget, sKey): EnhancedStore {
      // @ts-ignore
      return storeMethods.getStore()[sKey]
    }
  }
)

export { Components }

export const alertsActions = {
  errorAlert,
  successAlert,
  infoAlert,
  warningAlert,
  clearAlerts,
  clearAlertsAsync,
  removeAlert,
  getAlerts
}
export interface StoreAlertsState extends SNS {}
export interface StoreAlert extends SN {}

export const i18nInstance = i18nI

// Models
export const Models = {
  Paw,
  App,
  Bloc,
  Context,
  Folder,
  Space,
  User,
  ViewFolder,
  View,
  Doc,
  Group
}

// Interfaces
export interface PawConnectedModel<T> extends PawConnected<T> {}
export interface PawViewProps extends IViewProps {}
